// extracted by mini-css-extract-plugin
export default {"container":"ColorKey_container__FdfJs","header":"ColorKey_header__Bkmq-","list":"ColorKey_list__CC2Jh","title":"ColorKey_title__u7jLt"};